

import Message_root from "./message_root/message";
import Error_page from "./pages/error";
import Account from "./profile/account";
import Login from "./profile/login";
import Install_app from "./body_root/install-app";
import Chart_root from "./cart_root/chart";
import Search_root from "./search_root/search";
import Index from "./page_root/index";
import Support from "./support_root/support";
import Sitemap from "./body_root/sitemap";
import Account_profile from "./profile/account-profile";
//Dashboard
import Dashboard from "./dashboard_root/dashboard";


//Administration
import Administration from "./administration_root/administration";
import New_website_settings from "./administration_root/new-website-settings";
//page_manager Dashboard_editer
import Preview from "./dashboard_editer_root/preview";
import Dashboard_editer from "./dashboard_editer_root/dashboard-editer";
import Website_settings from "./dashboard_editer_root/website-settings";
import Editer from "./dashboard_editer_root/editer";
import Create_account from "./billing_settings_root/create-account";
import Billing from "./billing_settings_root/billing";
import Editer_home from "./dashboard_editer_root/editer-home";
import Editer_page from "./dashboard_editer_root/editer-page";

export const Approutes = [
  { path: '/', name: 'Home ', element: <Index /> },

//Administration
  { path: '/administration', name: 'Administration', element: <Administration /> },
   { path: '/new-website-settings', name: 'new website settings', element: <New_website_settings /> },
 //Dashboard
  { path: '/dashboard', name: 'Dashboard', element: <Dashboard /> },
  //page_manager dashboard
  { path: '/dashboard-editer', name: 'Dashboard', element: <Dashboard_editer /> },
  { path: '/preview', name: 'Preview', element: <Preview /> },
  { path: '/editer-home', name: 'Edit home', element: <Editer_home /> },
  { path: '/editer-page', name: 'Edit home', element: <Editer_page /> },
  { path: '/website-settings', name: 'Website settings', element: <Website_settings /> },
  { path: '/editer', name: 'Page editer', element: <Editer/> },
  { path: '/account-profile', name: 'Account profile', element: <Account_profile /> },
  { path: '/create-account', name: 'Create account', element: <Create_account /> },

  { path: '/billing', name: 'Account billing', element: <Billing /> },


  //website
  { path: '/support', name: 'Support', element: <Support /> },
  { path: '/search', name: 'search', element: <Search_root /> },
  { path: '/chart', name: 'Chart', element: <Chart_root /> },
  { path: '/message', name: 'Message', element: <Message_root /> },
  { path: '/account', name: 'Profile account', element: <Account /> },
  { path: '/login', name: 'Login account', element: <Login /> },

  { path: '/sitemap', name: 'Sitemap', element: <Sitemap /> },
  { path: '/install-app', name: 'install app', element: <Install_app /> },
  { path: '/error', name: 'error', element: <Error_page /> }
  //
];